import { createPortal } from 'react-dom';
import cn from 'classnames';

import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import CN from './MobileBottomSheet.module.scss';

export const MobileBottomSheet = ({ isOpen, onClose, children }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  return createPortal(
    <div data-bem="MobileBottomSheet" className={cn(CN.backdrop, { [CN.backdropVisible]: isOpen, [CN.dark]: isDarkMode })} onClick={onClose}>
      <div role="dialog" aria-modal="true" aria-label={t('mobileBottomSheet.ariaLabel')} tabIndex={-1} className={cn(CN.sheet, { [CN.sheetOpen]: isOpen })} onClick={(e) => e.stopPropagation()}>
        <div className={CN.sheetHeader}>
          <Button tag="MobileBottomSheet__closeButton" variant="icon" width="small" className={CN.closeButton} onClick={onClose} aria-label={t('mobileBottomSheet.closeButtonAriaLabel')}>
            <Icon variant="xCloseBlack" variantInvertDark={!isDarkMode} isCentered width="lg" />
          </Button>
        </div>

        <div className={CN.sheetContent}>{children}</div>
      </div>
    </div>,
    document.body,
  );
};
